import { render, staticRenderFns } from "./account-idtype.vue?vue&type=template&id=10fc7780&"
import script from "./account-idtype.vue?vue&type=script&lang=js&"
export * from "./account-idtype.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports